/* eslint-disable no-new */
import { FunctionComponent, useEffect, useRef, useState } from 'react'
// import Head from 'next/head'
import styled from 'styled-components'

import { formatAddress } from 'utils/listingHelpers'

import * as T from 'types'

const Container = styled.div`
  height: 400px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  @media (min-width: ${props => props.theme.metrics.tablet}px) {
    padding: 0 20px;
  }
`

interface IProps {
  listing: T.IListing
}

const GoogleMap: FunctionComponent<IProps> = ({ listing }) => {
  const googleMapRef = useRef<HTMLDivElement>(null)

  // const [mapShown, setMapShown] = useState(false)
  const [error, setError] = useState('')

  const createGoogleMap = (coordinates: any) => {
    if (!googleMapRef?.current) {
      setError("Couldn't load GoogleMap")
      return undefined // returning explicitly to avoid a typescript error
    }

    const googleMap = new window.google.maps.Map(googleMapRef.current, {
      zoom: 12,
      center: {
        lat: coordinates.lat,
        lng: coordinates.lng,
      },
    })
    return googleMap
  }

  const showMap = () => {
    // if (mapShown) return // only create the map/marker at most once
    // if (!listing.latitude && !listing.longitude) return // should never be true
    const googleMap = createGoogleMap({ lat: listing.latitude, lng: listing.longitude })
    if (!googleMapRef) return setError("Couldn't load GoogleMap")

    new window.google.maps.Marker({
      position: { lat: listing.latitude, lng: listing.longitude },
      map: googleMap,
      animation: window.google.maps.Animation.DROP,
      title: `${formatAddress(listing)}`,
    })
    // setMapShown(true)
  }

  useEffect(() => {
    if (!listing.latitude && !listing.longitude) return // should never be true

    showMap()
  }, [])

  // google maps script
  // const [loadMapScript, setLoadMapScript] = useState(false)
  // useEffect(() => {
  //   setTimeout(() => {
  //     if (typeof window !== 'undefined' && !window.google) {
  //       window.showMap = showMap // callback used by google maps script once loaded
  //       setLoadMapScript(true)
  //     } else {
  //       // if user has come from another page that has loaded window.google.maps,
  //       // it is safe to showMap immediately
  //       showMap()
  //     }
  //   }, 0)
  // }, [])

  // const renderHead = () => (
  //   <Head>
  //     <script
  //       src={`https://maps.googleapis.com/maps/api/js?key=${process.env.GOOGLE_API_KEY}&libraries=places&callback=showMap`}
  //     />
  //   </Head>
  // )

  if (error) return null

  return (
    <Container>
      {/* {loadMapScript && renderHead()} */}
      <div
        id="google-map"
        ref={googleMapRef}
        style={{ width: '100%', height: '100%' }}
      />
    </Container>
  )
}

export default GoogleMap
